<div class="drawer-layout">
  @if (!newObservation && !editObservation) {
    <div class="drawer-content flex-row justify-content-space-between align-items-center">
        <button mat-button
                class="drawer-action-button"
                (click)="onNewObservationClick()"
        >
          <mat-icon>add</mat-icon> <span class="button-label">Create Observation...</span>
        </button>
        <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                           [active]="showingFilterBar"
                           (toggled)="toggleFilter()"
        ></app-filter-button>
    </div>

    <div>
        <app-filter-bar
                [origin]="'observations'"
                [showingFilterBar]="showingFilterBar"
                [useDateFilter]="true"
                (dateFilterChanged)="onDateFilterChanged($event)"
                [useVehicleFilter]="true"
                (vehicleFilterChanged)="onVehicleFilterChanged($event)"
                [useDriverFilter]="true"
                (driverFilterChanged)="onDriverFilterChanged($event)"
                [useObservationTypeGroupFilter]="true"
                (observationTypeGroupFilterChanged)="onObservationTypeGroupFilterChanged($event)"
                (appliedFiltersChanged)="appliedFiltersCount = $event"
        >
        </app-filter-bar>
    </div>

    @if (!!items) {
        @if (items.length > 0) {
            <div class="drawer-content">
                @for (item of items; track item.id) {
                    <div>
                        <app-card-menu-item [item]="item" #itemRef [id]="'obs-'+item.id"></app-card-menu-item>
                    </div>
                }
            </div>
        }
        @if (items.length === 0) {
            <div class="drawer-content">
                <span>There are no observations for the filter set.</span>
            </div>
        }
    }
  } @else if (newObservation) {
    <div class="drawer-content">
      <app-new-observation
        (observationCreated)="onObservationCreated($event)"
        (createCanceled)="onCreateCanceled()"
      ></app-new-observation>
    </div>
  } @else if (editObservation) {
    <div class="drawer-content">
      <app-edit-observation
        [observation]="editObservation"
        (observationUpdated)="onObservationUpdated($event)"
        (updateCanceled)="onUpdateCanceled()"
      ></app-edit-observation>
    </div>
  }
</div>
